import { isObject } from "lodash-es";

const reportedShareDBErrors = new WeakSet<object>();

/** Marks an error as represented by an authoritative ShareDB log. */
export const markShareDBErrorReported = (error: unknown): void => {
  if (isObject(error)) {
    reportedShareDBErrors.add(error);
  }
};

/** Reports an error unless this exact object was already reported. */
export const reportShareDBErrorOnce = (error: unknown, report: () => void): boolean => {
  if (isObject(error)) {
    if (reportedShareDBErrors.has(error)) return false;
    reportedShareDBErrors.add(error);
  }

  report();
  return true;
};
